import * as routerHelper from '@/helpers/router.helper';

const hotelLinkageRoutes = {
  path: '/',
  name: 'hotelLinkage',
  component: () => import(/* webpackChunkName: "hotel-linkage" */ '@/views/Layout/HotelLinkageLayout.vue'),
  meta: {
    title: 'Welcome',
    documentTitle: '*login.hotelLinkageWelcome',
    public: true,
    guestOnly: true,
    translationKey: ['login', 'validation', 'links'],
  },
  children: [
    {
      path: '/login/:uuid([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})?',
      name: routerHelper.loginRouteName,
      component: () => import(/* webpackChunkName: "hotel-linkage-login" */ '@/views/Auth/HotelLinkage/Login.vue'),
      meta: {
        title: 'Welcome',
        documentTitle: '*login.pageTitle',
        public: true,
        guestOnly: true,
        translationKey: ['login', 'validation', 'links'],
      },
    },
    {
      path: '/direct-login',
      name: routerHelper.directLoginRouteName,
      meta: {
        title: 'Welcome',
        documentTitle: '*login.pageTitle',
        public: true,
        guestOnly: true,
        translationKey: ['login'],
      },
      component: () => import(/* webpackChunkName: "hotel-linkage-login" */ '@/views/Auth/HotelLinkage/Login.vue'),
    },
    {
      path: '/password/email',
      name: routerHelper.passwordEmailRouteName,
      meta: {
        title: 'Forgot Password',
        documentTitle: '*forgot-pwd.title',
        public: true,
        guestOnly: true,
        agent: false,
        translationKey: ['passwordEmail'],
      },
      component: () => import(/* webpackChunkName: "hotel-linkage-forgot-password" */ '@/views/Auth/HotelLinkage/ForgotPassword.vue'),
    },
    {
      path: '/password/change',
      name: routerHelper.passwordChangeRouteName,
      meta: {
        title: 'Change Password',
        documentTitle: '*change-pwd.title',
        public: true,
        guestOnly: true,
        agent: false,
        translationKey: ['passwordChange'],
      },
      component: () => import(/* webpackChunkName: "hotel-linkage-change-password" */ '@/views/Auth/HotelLinkage/ChangePasswordSent.vue'),
    },
    {
      path: '/password/reset',
      name: routerHelper.passwordResetRouteName,
      meta: {
        title: 'Reset Password',
        documentTitle: '*reset-pwd.title',
        public: true,
        guestOnly: true,
        agent: false,
        translationKey: ['passwordReset'],
      },
      component: () => import(/* webpackChunkName: "hotel-linkage-reset-password" */ '@/views/Auth/HotelLinkage/ResetPassword.vue'),
    },
  ],
};

export default hotelLinkageRoutes;
